import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { ProjectWithNationsFilterData } from '../../types/projectWithNation';
import { TProjectWithRegionsState } from '../projectWithRegions/types';
import { PROJECT_WITH_NATIONS_ACTIONS_NAME, PROJECT_WITH_NATIONS_MUTATIONS_NAME } from './name';
import { TProjectWithNationsState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchProjects(
  context: ActionContext<TProjectWithRegionsState, unknown>,
  payload: TBaseFilterPayload<ProjectWithNationsFilterData & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ves.projectWithNations.searchProjects,
      name: PROJECT_WITH_NATIONS_ACTIONS_NAME.searchProjects,
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getProjectsInForeignCountriesDatesCount(
  context: ActionContext<TProjectWithNationsState, unknown>,
  params: ProjectWithNationsFilterData,
) {
  context.commit(getLocalState(PROJECT_WITH_NATIONS_MUTATIONS_NAME.setIsLoadingCount), true);

  await request(
    context,
    {
      url: links.ves.projectWithNations.getProjectsInForeignCountriesDatesCount,
      mutate: getLocalState(PROJECT_WITH_NATIONS_MUTATIONS_NAME.setProjectsInForeignCountriesDatesCount),
      name: getLocalState(PROJECT_WITH_NATIONS_ACTIONS_NAME.getProjectsInForeignCountriesDatesCount),
    },
    params,
  );

  context.commit(getLocalState(PROJECT_WITH_NATIONS_MUTATIONS_NAME.setIsLoadingCount), false);
}
